module.exports = __webpack_public_path__ + "img/trusted-company-3.52c47994.png";